// noinspection ES6ConvertVarToLetConst

// <div ng-controller="ExampleCtrl as exCtrl">
//   <span>{{ exCtrl.myVar }}</span>
//   <span>{{ exCtrl.myFunc() }}</span>
// </div>

// no script tag in head is needed, this should immediately start working if you are running ./gradlew gulp_watch

var SwitchListCtrl = function ($scope) {
  'use strict'

  $scope.rowCollection = null

  function getRole(row, sep) {
    return row.orgName + sep + (row.ouName ? '/' + row.ouName + '/' : '') + sep + (row.roleString ? row.roleString : '')
  }

  $scope.initRowCollection = function (roles) {
    $scope.rowCollection = roles.map(function (row) {
      row.role = getRole(row, ' ')
      row.altRole = getRole(row, '')
      return row
    })
  }

  return $scope
}

ExampleCtrl.$inject = ['$scope']
angular.module('app').controller('SwitchListCtrl', SwitchListCtrl); // one semi at end of file is a must or lots of things break!
